import { Component, OnInit, Inject } from '@angular/core';
import { IbCLinkPipe } from 'ib-web-commons/pipes';
import { downgradeToAJSComponent, AJSRootScope, CommonsRootScope } from 'ib-web-commons/utils';
import { TranslateService } from '@ngx-translate/core';
import { GiftCardsAppConstants } from '@src/app/shared/constants/ib-gift-cards-constants';
import { Summary, SummaryProps } from 'commercial-management--ancillaries--web-components-design--library/ancillaries-web-components';
import { GiftCardsPaymentService } from '../../../payments/services/ib-gift-cards-payments/ib-gift-cards-payments-service';
import { lastValueFrom } from 'rxjs';
import { ReactComponentData } from '@src/app/core/models/generic-models/generic-models';
import { GiftCardsConfirmationDeliveryType, GiftCardsConfirmationType, issueOrderInfo } from '@src/app/core/models/confirmation.model';
import { AJSGiftCardsDatalayerService, GiftCardsDatalayerServiceType } from '../../../../../shared/services/upgrades/ib-gift-cards-datalayer-bridge-service';
import { GiftCardTheme } from '@src/app/core/models/campaigns.model';
import { CampaignsService } from '../../../../../shared/services/ib-gift-cards-campaigns/ib-gift-cards-campaigns.service';
import { GiftCardsSessionStorageService } from '@src/app/core/services/ib-gift-cards-session-storage/gift-cards-session-storage.service';

@Component({
    selector: 'ib-gc-confirmation-component',
    templateUrl: './ib-gift-cards-confirmation.component.html',
    styleUrls: ['./ib-gift-cards-confirmation.component.scss']
})

export class IbGiftCardsConfirmationComponent implements OnInit {
    theme: string;
    recipientEmail: string;
    senderEmail: string;
    typesOfShipping: GiftCardsConfirmationDeliveryType;
    typeOfCard: GiftCardsConfirmationType;
    confimationEmailLiteral: string;
    twitterLink: string;
    issueOrderInfo: issueOrderInfo;
    ibPayTrace;
    dateTimeLocalUTC: string;
    protected viewModel: GiftCardTheme;

    public summaryComponent: ReactComponentData<SummaryProps> = {
        component: Summary,
        props: {} as SummaryProps
    };


    constructor (
        private translateService: TranslateService,
        private CampaignsService: CampaignsService,
        private ibCLinkPipe: IbCLinkPipe,
        @Inject(AJSRootScope) protected rootScope: CommonsRootScope,
        private giftCardsPaymentService: GiftCardsPaymentService,
        private GiftCardsSessionStorageService: GiftCardsSessionStorageService,
        @Inject('localStorageService') private localStorageService: angular.local.storage.ILocalStorageService,
        @Inject(AJSGiftCardsDatalayerService) private giftCardsDatalayerService: GiftCardsDatalayerServiceType
    ) {
    }

    ngOnInit (): void {
        this.populateData();
        this.giftCardsDatalayerService.updateDigitalDataWithQuadrigam(GiftCardsAppConstants.QUADRIGAMS.REBKCF);
        this.initCampaignInfo();
    }

    initCampaignInfo () {
        this.CampaignsService.buildCardViewModel(this.theme)
            .then(viewModel => {
                this.viewModel = viewModel;
            });
    }

    private generateDate = (sessionStorageConfigInfo: Types.ConfigurationModel) => {
        let issueDate = sessionStorageConfigInfo?.shippingInfo.delivery.dateTime;
        
        this.calculateUTC0DateTimeGiftCardGroup(issueDate);
    };
    private populateData = async ():Promise<void> => {

        this.giftCardsPaymentService.updateSteps('confirmation');
        this.issueOrderInfo = this.GiftCardsSessionStorageService.get('issueOrderInfo');
        
        const sessionStorageConfigInfo = this.GiftCardsSessionStorageService.get<Types.ConfigurationModel>(GiftCardsAppConstants.SESSION_STORAGE.CONFIGURATION_INFO);
        this.generateDate(sessionStorageConfigInfo);
        
        this.GiftCardsSessionStorageService.set('nextStepAllowed', false);
        
        this.defineShippingType(sessionStorageConfigInfo);
        this.defineTypeOfCard(sessionStorageConfigInfo);

        this.theme = sessionStorageConfigInfo?.themeGift?.theme ?? 'GIFT';
        const shippingInfo = sessionStorageConfigInfo?.shippingInfo;
        this.recipientEmail = shippingInfo?.emailEmailReceiver !== null ? shippingInfo?.emailEmailReceiver : this.issueOrderInfo?.data?.giftCardInfo?.receiver.email;
        this.senderEmail = shippingInfo?.emailEmailSender !== null ? shippingInfo?.emailEmailSender : this.issueOrderInfo?.data?.giftCardInfo?.sender.email;
        const confimationEmailText = await lastValueFrom(this.translateService.get('GIFT_CARD_COMFIRMATION_GIFTCARD_EMIT_TEXT_2'));
        this.confimationEmailLiteral = confimationEmailText.replace('{{email}}', this.senderEmail );
        this.summaryComponent.props = this.localStorageService.get(GiftCardsAppConstants.SESSION_STORAGE.SUMMARY, 'localStorage')  as SummaryProps;
        // this.ibPayTrace = this.localStorageService.get('ibPayTrace'); //?
        this.twitterLink = this.ibCLinkPipe.transform('TWITTER_LINK');
    };

    defineShippingType = (sessionStorageConfigInfo): void => {
        this.typesOfShipping = {
            forOneSelf: sessionStorageConfigInfo?.destinyGift?.destiny === 'mine',
            forAnotherByEmail: sessionStorageConfigInfo?.destinyGift?.destiny !== 'mine' && (sessionStorageConfigInfo?.shippingInfo?.shippingOptionEmail && !sessionStorageConfigInfo?.shippingInfo?.shippingOptionSender),
            forAnotherByHand: sessionStorageConfigInfo?.destinyGift?.destiny !== 'mine' && (!sessionStorageConfigInfo?.shippingInfo?.shippingOptionEmail && sessionStorageConfigInfo?.shippingInfo?.shippingOptionSender),
            forAnotherByEmailAndHand: sessionStorageConfigInfo?.destinyGift?.destiny !== 'mine' && (sessionStorageConfigInfo?.shippingInfo?.shippingOptionEmail && sessionStorageConfigInfo?.shippingInfo?.shippingOptionSender)
        };
    };
    defineTypeOfCard = (sessionStorageConfigInfo): void => {
        this.typeOfCard = {
            isGiftCard: sessionStorageConfigInfo?.participationCheckboxGroup != 'true' && sessionStorageConfigInfo?.flow != 'contribution',
            isGiftCardColavorative: sessionStorageConfigInfo?.participationCheckboxGroup == 'true' || 
                                    (sessionStorageConfigInfo?.flow == 'contribution' && 
                                     sessionStorageConfigInfo?.participationCheckboxGroup != 'true')
        };
        if(this.typeOfCard.isGiftCardColavorative){
            this.typeOfCard = {
                ...this.typeOfCard,
                colavorativeType: {
                    isContribution: sessionStorageConfigInfo?.flow == 'contribution' && 
                                    sessionStorageConfigInfo?.participationCheckboxGroup != 'true'
                }
            };
        }
    };

    checkFormatDate (dateToCheck): string {
        const trakingCode: string = this.GiftCardsSessionStorageService.get('TrackingCode');
        const language = trakingCode.split('/')[0];
        const isInvalidDate: boolean = language === 'es';

        if(!isInvalidDate) {
            return dateToCheck;
        }else {
            const [datePart, ...time] = dateToCheck.split(' ');
            const dateSplited = datePart.split('/');
            return `${dateSplited[1]}/${dateSplited[0]}/${dateSplited[2]} ${time}`;
        }
    }
    calculateUTC0DateTimeGiftCardGroup (dateToCalculate) {
        const localDate = new Date();
        const minutesDifferenceWithUTC = localDate.getTimezoneOffset();
        const dateTemp = new Date(dateToCalculate);
        const diferenceHours = parseInt(localDate.getTimezoneOffset().toString().replace('-', '').replace('+', ''));
        minutesDifferenceWithUTC > 0 ? dateTemp.setHours(dateTemp.getHours() - (diferenceHours / 60)).toString()  : dateTemp.setHours(dateTemp.getHours() + (diferenceHours / 60 ) );
        const dateReturn = `${dateTemp.getFullYear()}-${(dateTemp.getMonth() +1).toString().length === 1 ? `0${(dateTemp.getMonth() +1)}`: `${(dateTemp.getMonth() +1)}`}-${dateTemp.getDate().toString().length === 1 ? `0${dateTemp.getDate()}`: `${dateTemp.getDate()}`} ${dateTemp.getHours().toString().length === 1 ? `0${dateTemp.getHours()}`: `${dateTemp.getHours()}`}:00`;
        this.dateTimeLocalUTC = dateReturn;
    }

    printSummary (): void {
        window.print();
    }

    /**
     * Returns the market from url
     * @returns {string} - returns an string made from params
     */
    getParameterByName = (name: string, url?: string): string => {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)', 'gi' );
        const results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return null;
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    };
}

downgradeToAJSComponent('ibGcConfirmationComponent', {
    component: IbGiftCardsConfirmationComponent,
    inputs: []
}, 'ib-gift-cards-confirmation');
